import * as React from 'react';
import { LoadOptions, Options } from 'ui';

/**
 * Includes the Not Selected code in calls to load options.
 */
export function withNotSelectedOptionIncluded<P extends Partial<Options<any>>>(
  WrappedComponent: React.ComponentClass<P>
): React.ComponentClass<P> {
  return class extends React.Component<P> {
    private onLoadOptions = (options: LoadOptions): void => {
      if (this.props.onLoadOptions) {
        this.props.onLoadOptions({ displayNotSelected: true, ...options });
      }
    }

    public render() {
      return <WrappedComponent {...this.props} {...{onLoadOptions: this.onLoadOptions}} />;
    }
  };
}
